import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import MicIcon from '@mui/icons-material/Mic';
import { db } from "../../firebase/config";
import {
  collection,
  addDoc,
    onSnapshot,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import ProductosModal from './formModal'; // Asegurate de importar tu modal
import { Button } from '@mui/material'; // Si no lo tenés ya


function FormTienda() {
  const [formData, setFormData] = useState({
    nombre: "",
    categoria: "",
    talles: "",
    precio: "",
    stock: "",
    descripcion: ""
  });

  const [isListening, setIsListening] = useState(false);

  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();

  recognition.lang = "es-ES";
  recognition.interimResults = false;

  const startListening = () => {
    setIsListening(true);
    recognition.start();

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setFormData((prevData) => ({ ...prevData, descripcion: transcript }));
      setIsListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Error de reconocimiento de voz:", event.error);
      setIsListening(false);
    };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    if (editandoId) {
      // Si es edición
      const productoRef = doc(db, "productos", editandoId);
      await updateDoc(productoRef, formData);
      setEditandoId(null);
    } else {
      // Si es nuevo
      await addDoc(collection(db, "productos"), formData);
    }

    Swal.fire({
      title: '¡Gracias!',
      text: editandoId ? 'Producto actualizado.' : 'Producto cargado.',
      icon: 'success',
      showConfirmButton: false,
      timer: 1200
    });

    setFormData({
      nombre: "",
      talles: "",
      precio: "",
      stock: "",
      descripcion: "",
      categoria: ""
    });

  } catch (error) {
    console.error("Error:", error);
    Swal.fire({
      title: 'Error',
      text: 'No se pudo guardar.',
      icon: 'error',
      confirmButtonText: 'Aceptar'
    });
  }
};



  const [openModal, setOpenModal] = useState(false);

const handleOpenModal = () => setOpenModal(true);
const handleCloseModal = () => setOpenModal(false);

const [editandoId, setEditandoId] = useState(null);

const handleEdit = (item) => {
  handleCloseModal();
  setFormData({
    nombre: item.nombre || "",
    talles: item.talles || "",
    precio: item.precio || 0,
    stock: item.stock || 0,
    descripcion: item.descripcion || "",
    categoria: item.categoria || ""
  });
  setEditandoId(item.id);
};


const exportToExcel = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "productos"));
    const productosData = [];
    querySnapshot.forEach((doc) => {
      productosData.push(doc.data());
    });

    // Crear hoja de cálculo
    const worksheet = XLSX.utils.json_to_sheet(productosData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Productos");

    // Exportar
    XLSX.writeFile(workbook, "productos.xlsx");

  } catch (error) {
    console.error("Error al exportar:", error);
    Swal.fire({
      title: 'Error',
      text: 'No se pudo exportar.',
      icon: 'error',
      confirmButtonText: 'Aceptar'
    });
  }
};


  return (
    <div  className="formulario-producto_tienda">
    <form onSubmit={handleSubmit} className="book-form">
      <div className="form-group">
        <label>NOMBRE:</label>
        <input
          type="text"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          className="form-input"
        />
      </div>
      <div className="form-group">
      <label>Categoría:</label>
  <select
    name="categoria"
    value={formData.categoria}
    onChange={handleChange}
    className="form-input"
  >
    <option value="">Seleccionar categoría</option>
    <option value="Abrigos">Abrigos</option>
    <option value="Blazers">Blazers</option>
    <option value="Bodies">Bodies</option>
    <option value="Camisas">Camisas</option>
    <option value="Camperas">Camperas</option>
    <option value="Carteras">Carteras</option>
    <option value="Chalecos">Chalecos</option>
    <option value="Jeans">Jeans</option>
    <option value="Pantalones">Pantalones</option>
    <option value="Polleras">Polleras</option>
    <option value="Remeras">Remeras</option>
    <option value="Suéteres">Suéteres</option>
    <option value="Zapatillas">Zapatillas</option>
  </select>
  </div>
      <div className="form-group">
        <label>TALLES:</label>
        <input
          type="text"
          name="talles"
          value={formData.talles}
          onChange={handleChange}
          className="form-input__titulo"
        />
      </div>
      <div className="form-group">
        <label>PRECIO:</label>
        <input
          type="number"
          name="precio"
          value={formData.precio}
          onChange={handleChange}
          className="form-input"
        />
      </div>
      <div className="form-group">
        <label>STOCK:</label>
        <input
          type="number"
          name="stock"
          value={formData.stock}
          onChange={handleChange}
          className="form-input"
        />
      </div>
      <div className="form-group">
        <label>Descripción:</label>
        <textarea
          name="descripcion"
          value={formData.descripcion}
          onChange={handleChange}
          className="form-input textarea"
        />
        <button
          type="button"
          onClick={startListening}
          className="voice-button"
          aria-label="Escuchar para completar descripción"
        >
          {isListening ? "🔴" : <MicIcon />}
        </button>
      </div>
      <button type="submit" className="submit-button">
        Cargar Producto
      </button>
    </form>
<Button
  variant="contained"
  color="success"
  onClick={exportToExcel}
  style={{ margin: 10 }}
>
  Exportar a Excel
</Button>
 <br />
      <Button
    variant="contained"
    color="secondary"
    onClick={handleOpenModal}
    className="boton-excel"
    style={{ margin: 10 }}
  >
    Ver Listado
  </Button>

  <ProductosModal
    openModal={openModal}
    handleCloseModal={handleCloseModal}
    handleEdit={handleEdit}
  />
    </div>
  );
}


export default FormTienda;